export function quickDiscountPercents(effectiveMax) {
  const cap = Number(effectiveMax);
  if (!Number.isFinite(cap) || cap <= 0) return [];
  const steps = cap <= 5 ? [2] : cap <= 10 ? [5] : [5, 10, 15, 20];
  return [...new Set([...steps.filter((value) => value < cap), cap])];
}

export function validDiscountPercent(value, effectiveMax) {
  if (!/^\d+(?:\.\d{1,2})?$/.test(String(value))) return false;
  const percent = Number(value);
  return percent > 0 && percent <= Number(effectiveMax);
}
